import graphql__c81df628a5662951eaba from "./__generated__/ParticipativeModuleLayout_participativeModule.graphql.js";import { useFragment } from "react-relay";
import { graphql } from "react-relay";
import { defineMessages } from "react-intl";

import Steps from "../Steps/Steps";
import PageSections from "../PageSection/PageSections";
import ContributeButton from "./ContributeButton";
import RichText from "../Utils/RichText";
import { hasHtmlContent } from "../Utils/htmlStringUtils";
import TitleBarWithAction from "./TitleBarWithAction";
import { useFormatMessage } from "../Intl/Context";
import { isUnauthorized } from "../Utils/authorizations";
import PushableContainer from "../Utils/PushableContainer";
import { useResponsiveFlag } from "../Utils/ResponsiveQueries";

const ParticipativeModuleLayout = props => {
  const participativeModule = useFragment(
    ParticipativeModuleLayout_participativeModule,
    props.participativeModule
  );

  const { isNonDesktop } = useResponsiveFlag();

  const t = useFormatMessage();
  const stepsTitle = t(intlMessages.stepsTitle);

  const { children } = props;
  const { message } = participativeModule;
  const { contributionsSubmissionAuthorized } = participativeModule.authorizations;
  const { isFullScreen } = participativeModule.visualization;

  // Do not display the participative module layout if the module is meant to be displayed
  // full screen
  if (isFullScreen) return children;

  const messageNode = hasHtmlContent(message) && (
    <RichText
      className="box margin-bottom-xs text-default padding-md"
      content={message}
    />
  );

  // Check that the contribution action is authorized before generating the button action
  // to avoid the TitleBarWithAction component to display a blank space when the action
  // is unauthorized.
  const titleAction = !isUnauthorized(contributionsSubmissionAuthorized) && (
    <ContributeButton
      participativeModule={participativeModule}
      className="btn btn-primary btn-block-md box-shadow-lg btn-expand-height"
    />
  );

  const { displayParticipativeModuleStepsAfterSections } = participativeModule;

  const steps = (
    <Steps key="steps-details" steppable={participativeModule} title={stepsTitle} />
  );
  const sections = (
    <PageSections page={participativeModule} className="margin-bottom-xs" />
  );

  return (
    <PushableContainer
      className="container participative-module-layout-container"
      preventPush={isNonDesktop}
    >
      <TitleBarWithAction resource={participativeModule} action={titleAction} />

      {displayParticipativeModuleStepsAfterSections ? (
        <>
          {sections}
          {messageNode}
          {steps}
        </>
      ) : (
        <>
          {messageNode}
          {steps}
          {sections}
        </>
      )}

      {children}
    </PushableContainer>
  );
};

const ParticipativeModuleLayout_participativeModule = graphql__c81df628a5662951eaba;

export default ParticipativeModuleLayout;

const intlMessages = defineMessages({
  stepsTitle: {
    id: "participativeModule.show.stepsTitle",
    defaultMessage: "Déroulement de la participation"
  }
});
